import { HTTP } from '../services'
import buildQuery from '@/helpers/url'
import { store } from '@/store'

export default new (class CompanyService {
	getAll (params) {
		if (params) {
			params = buildQuery(params)
		}
		return HTTP.get('/v1/companies?' + params)
	}

	getCompanyById (data) {
		return HTTP.get('/v1/companies/' + data.id)
	}

	getCompanyLeads (id, page) {
		let params = {
			page: page || 1
		}
		return HTTP.get('/v1/companies/' + id + '/leads?' + buildQuery(params))
	}

	getCompanyRecentLeads (id, days = 30) {
		let params = { days: days }
		return HTTP.get('/v1/companies/' + id + '/leads/recent?' + buildQuery(params))
	}

	getCompanyActiveEvents (id) {
		return HTTP.get('/v1/companies/' + id + '/events/active')
	}

	createCompany (data) {
		return HTTP.post('/v1/companies', data)
	}

	updateCompany (id, data) {
		return HTTP.put('/v1/companies/' + id, data)
	}

	deleteCompany (id) {
		return HTTP.delete('/v1/companies/' + id)
	}

	searchCompanies (params) {
		return HTTP.get('/v1/companies/search?' + buildQuery(params))
	}

	// Get industries for dropdown
	getIndustries () {
		return HTTP.get('/v1/companies/industries')
	}

	// Get primary markets for dropdown (static list)
	getPrimaryMarkets () {
		return Promise.resolve({
			data: [
				{ value: 'AU', label: 'Australia' },
				{ value: 'UK', label: 'United Kingdom' }
			]
		})
	}

	// Associate leads with a company
	associateLeads (companyId, leadIds) {
		return HTTP.post(`/v1/companies/${companyId}/leads/associate`, {
			lead_ids: leadIds
		})
	}

	// Remove lead association from a company
	removeLeadAssociation (companyId, leadId) {
		return HTTP.delete(`/v1/companies/${companyId}/leads/${leadId}/association`)
	}

	// Merge companies - transfer all leads from source to target and delete source
	mergeCompanies (targetCompanyId, sourceCompanyId) {
		return HTTP.post(`/v1/companies/${targetCompanyId}/merge`, {
			source_company_id: sourceCompanyId
		})
	}

	// Sync company to HubSpot with all associated leads and events
	syncToHubSpot (companyId) {
		return HTTP.post(`/v1/companies/${companyId}/sync-to-hubspot`)
	}

	formatCompanyComponentData (data, current) {
		let selected = []

		for (let row in current) {
			selected.push(current[row].id)
		}
		let temp = current
		for (let row in data) {
			if (selected.indexOf(data[row].id) === -1) {
				temp.push(data[row])
				selected.push(data[row].id)
			}
		}

		return temp
	}
})()